import React, { memo } from 'react';
import Link from '@mui/material/Link';

const ExternalLink = (props) => {
  return (
    <Link
      href={props.href}
      target={'_blank'}
      rel={'noopener noreferrer'}
      underline="hover">
      {props.children}
    </Link>
  );
};

export default memo(ExternalLink);
